import { render, staticRenderFns } from "./TextImage2.vue?vue&type=template&id=6f5acc53&scoped=true"
import script from "./TextImage2.vue?vue&type=script&lang=js"
export * from "./TextImage2.vue?vue&type=script&lang=js"
import style0 from "./TextImage2.vue?vue&type=style&index=0&id=6f5acc53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5acc53",
  null
  
)

export default component.exports